import { ReadingContextInterface } from "context/initialState/Readings";
import { useState } from "react";
import {
  ButtonGroup,
  Stack
} from "@mui/material";
import { BasicText, BoldText } from "./Attributes.styles";
import HighchartsReact from "highcharts-react-official";
import Button from "components/shared/Button/Button";
import Highcharts from "highcharts";
import {
  formatChart,
  formatSeries,
  getXAxisConfig,
  getYAxisRange
} from "../Chart/Chart.utility";
import moment from "moment";
import {t} from "i18next";

export function ActivityReadingChart({ reading }: { reading: ReadingContextInterface | undefined }) {
  const [chartType, setChartType] = useState<"line" | "column">("column");

  const utcBatches = ((reading?.metrics as any)?.readings ?? []);

  const points: [number, number][] = utcBatches
    .map((reading: any): [number, number] => {
      const timeStr = String(reading.measuredAt).replace(/([Zz]|[+-]\d\d:?\d\d)$/, "");
      return [Date.parse(timeStr + "Z"), reading.metrics?.steps ?? 0];
    })
    .sort((a: [number, number], b: [number, number]) => a[0] - b[0]);

  const total = points.reduce((sum, [, steps]) => sum + steps, 0);

  const dayStr = String(reading?.measuredAt ?? "").slice(0, 10);
  const start = Date.parse(dayStr + "T00:00:00Z");
  const end = Date.parse(dayStr + "T23:59:59Z");

  const yAxisRange = getYAxisRange("activity", points.length > 0);
  const isColumns = chartType === "column";

  const options = {
    time: { timezoneOffset: 0 },
    chart: { type: chartType, plotBorderColor: "black", plotBorderWidth: 1.25 },
    ...(isColumns
      ? { plotOptions: { column: { pointRange: 3600 * 1000, borderRadius: 2, pointPadding: 0.1, groupPadding: 0.05 } } }
      : {}),
    title: { text: null },
    xAxis: {
      type: "datetime",
      gridLineDashStyle: "Dash",
      min: start,
      max: end,
      tickInterval: 3600 * 1000,
      labels: { rotation: -45, format: "{value:%H:%M}" },
    },
    yAxis: {
      min: 0,
      max: yAxisRange?.max,
      startOnTick: true,
      endOnTick: true,
      title: { text: null },
      gridLineColor: "black",
      gridLineWidth: 1.25,
      plotBands: [],
    },
    legend: { enabled: true },
    tooltip: { shared: true, xDateFormat: "%H:%M" },
    series: [{ name: "Activity", data: points }],
  };

  if (points.length === 0) {
    return <BasicText>{t("u-no-data")}</BasicText>;
  }

  return (
    <Stack spacing={1}>
      <Stack direction="row" spacing={1} alignItems="center">
        <BoldText>Total:</BoldText>
        <BasicText>{total} steps</BasicText>
        <ButtonGroup>
          <Button variant="info" selected={chartType === "column"} onClick={() => setChartType("column")}>Bar</Button>
          <Button variant="info" selected={chartType === "line"} onClick={() => setChartType("line")}>Line</Button>
        </ButtonGroup>
      </Stack>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Stack>
  );
}